import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(159, 159, 159, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
`;
